import React from 'react'
import { useUser } from 'src/Hooks/useUser'
import { useUserInvitations } from 'src/Libs/installation-rights-management/hooks/use-user-invitations'
import InvitationsDialog from './InvitationsDialog'

/**
 * After login, checks whether the authenticated user has any open
 * invitations (e.g. from clicking an invitation link before creating their
 * account). If found, the invitation pop-up is displayed automatically.
 */
const InvitationCheck: React.FC = () => {
  const { userData } = useUser()
  const isUserLevelUser = userData?.level === 'USER'

  const { data: invitations, isLoading } = useUserInvitations(userData?.ID, isUserLevelUser)

  if (!invitations?.length) return null

  return <InvitationsDialog userInvitations={invitations} isUserInvitationLoading={isLoading} />
}

export default InvitationCheck
